const zipLookup = () => {
    const $$$ = document.querySelectorAll.bind(document);
    const lang = $('html').attr('lang') === 'es-US' ? 'es' : 'en';

    // click on the Check Availability button
    $$$('.provider-zip-check__button').forEach((i) => {
        i.addEventListener('click', (e) => {
            // set whatever this is in to its current width
            const checkContainer = i.parentElement.parentElement.parentElement;
            console.log(checkContainer.offsetWidth);
            checkContainer.style.width = `${checkContainer.offsetWidth}px`;

            // set width and height on element to maintain consistency
            const thisWidth = i.offsetWidth;
            i.parentElement.parentElement.style.width = `${thisWidth}px`;

            e.currentTarget.classList.add('off');
            e.currentTarget.nextElementSibling.classList.add('on');
            e.currentTarget.nextElementSibling
                .querySelector('input[name="zip"]')
                .focus();
        });
    });

    // click the "edit zip" button
    $$$('.provider-zip-check__edit').forEach((i) => {
        const parentCheck = i.parentElement.parentElement.parentElement;
        const parentUnavailable = i.parentElement.parentElement;
        const providerLink = parentUnavailable.querySelector(
            '.provider-zip-check__new'
        );

        i.addEventListener('click', () => {
            parentUnavailable.classList.remove('on');
            parentCheck.classList.remove('showing');
            parentCheck
                .querySelector('.provider-zip-check__form-container')
                .classList.add('on');
            parentCheck.querySelector('input[name="zip"]').value = '';
            parentCheck.querySelector('input[name="zip"]').focus();
            providerLink.classList.remove('hide');
        });
    });

    // submit the form
    $$$('.provider-zip-check__form').forEach((i) => {
        i.addEventListener('submit', (e) => {
            e.preventDefault();
            const thisForm = e.currentTarget;
            const thisContainer = thisForm.parentElement.parentElement;
            const autoRedirectZip = thisForm.querySelector('.button').value;
            const autoRedirectLink =
                thisForm.parentElement.parentElement.querySelector(
                    '.provider-link'
                ).href;
            thisForm.querySelector('.button').classList.add('active');
            const dataString = new FormData(thisForm);
            // send zip and provider to check
            const providerLink = thisContainer.querySelector(
                '.provider-zip-check__new'
            );

            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/wp/wp-admin/admin-ajax.php',
                data: `action=checkZipProvider&zip=${dataString.get(
                    'zip'
                )}&provider=${dataString.get('provider')}`,
                success: (res) => {
                    $('.provider-zip-check__form input[name="zip"]').val(
                        dataString.get('zip')
                    );
                    // has provider and SHOULD automatically redirect to provider page
                    if (res.result !== 'no' && autoRedirectZip) {
                        window.dataLayer.push({
                            event: 'serviceAvailable',
                            provider: res.name,
                        });
                        window.location = autoRedirectLink;
                    } else {
                        // has provider and SHOULD NOT automatically redirect to provider page
                        thisForm
                            .querySelector('.button')
                            .classList.remove('active');
                        thisContainer.classList.add('showing');
                        thisForm.parentElement.classList.remove('on');
                        if (res.result !== 'no') {
                            const linkAvailable = thisContainer.querySelector(
                                '.provider-link__available'
                            );
                            const linkAvailableText =
                                thisContainer.querySelector(
                                    '.provider-link__available-text'
                                );

                            linkAvailable.classList.add('on');
                            if (lang === 'es') {
                                linkAvailableText.textContent = `Disponible en ${dataString.get(
                                    'zip'
                                )}`;
                            } else {
                                linkAvailableText.textContent = `Available in ${dataString.get(
                                    'zip'
                                )}`;
                            }
                        } else {
                            if (res.state === '') {
                                providerLink.classList.add('hide');
                                providerLink.parentElement.classList.add(
                                    'top-8'
                                );
                            }
                            // no provider
                            const linkUnavailable = thisContainer.querySelector(
                                '.provider-link__unavailable'
                            );
                            const linkUnavailableInput =
                                thisContainer.querySelector(
                                    '.provider-link__unavailable input'
                                );

                            linkUnavailable.classList.add('on');
                            if (lang === 'es') {
                                linkUnavailableInput.value = `No disponible en ${dataString.get(
                                    'zip'
                                )}`;
                            } else {
                                linkUnavailableInput.value = `Unavailable in ${dataString.get(
                                    'zip'
                                )}`;
                            }
                            linkUnavailableInput.disabled = true;

                            if (lang === 'es') {
                                providerLink.textContent = `Ver proveedores en ${dataString.get(
                                    'zip'
                                )}`;
                            } else {
                                providerLink.textContent = `See providers in ${dataString.get(
                                    'zip'
                                )}`;
                            }
                            providerLink.href = `/${res.state}/${
                                res.city
                            }?zip=${dataString.get('zip')}`;
                        }
                    }
                },
                error: () => {
                    console.log('Providers Zip lookup error');
                },
            });
        });
    });
};

export { zipLookup };
